/*
 * Copyright (C) 2020 Airfordable, Inc - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 */

import { styled, Theme } from '@material-ui/core';
import { CSSProperties } from '@material-ui/styles';
import React from 'react';

import { Breakpoints } from 'utils/enums';

const NavigationButton = styled(({ active: _, ...p }) => <button {...p} />)<
  Theme,
  { active: boolean }
>(({ theme, active }) => {
  const size = theme.spacing(9);
  const lineSize = size / 2;
  const lineSizeUnit = size / 8;

  const commonStyle: CSSProperties = {
    background: theme.palette.primary.main,
    content: '""',
    display: 'block',
    height: 2,
    left: lineSize / 2,
    position: 'absolute',
    transition: theme.transitions.create('all', {
      easing: theme.transitions.easing.easeInOut,
    }),
    width: lineSize,
  };

  return {
    '&::after': {
      ...commonStyle,
      top: lineSizeUnit * 3 + (active ? lineSizeUnit * 0.75 : 0),
      transform: `rotate(${active ? '-45deg' : 0})`,
    },

    '&::before': {
      ...commonStyle,
      top: lineSizeUnit * 4.5 - (active ? lineSizeUnit * 0.75 : 0),
      transform: `rotate(${active ? '45deg' : 0})`,
    },

    background: 'none',
    border: 0,
    height: size,
    padding: 0,
    position: 'absolute',
    right: theme.typography.pxToRem(-8),
    top: 'calc( 50% - 1px )',
    transform: 'translateY(-50%)',
    width: size,

    [theme.breakpoints.up(Breakpoints.Md)]: {
      display: 'none',
    },
  };
});

const MobileColMenu = styled(({ active: _, ...p }) => <div {...p} />)<
  Theme,
  { active: boolean }
>(({ theme, active }) => ({
  '& a': {
    color: 'inherit',
    display: 'inline-block',
    marginBottom: theme.spacing(2),
    marginTop: theme.spacing(2.25),
    textDecoration: 'none',
    [theme.breakpoints.up(Breakpoints.Md)]: {
      marginRight: theme.spacing(10),
    },
  },

  backgroundColor: theme.palette.background.default,
  display: 'flex',
  height: '100vh',
  left: 0,
  opacity: active ? 1 : 0,
  pointerEvents: active ? 'auto' : 'none',
  position: 'fixed',
  top: 0,
  transition: theme.transitions.create('opacity', {
    easing: theme.transitions.easing.easeInOut,
  }),
  width: '100vw',
  zIndex: 1,

  [theme.breakpoints.up(Breakpoints.Md)]: {
    display: 'none',
  },
}));

const MobileContainerMenu = styled('div')(({ theme }) => ({
  '& div': {
    justifyContent: 'center',
  },

  '& p': {
    fontWeight: 500,
  },

  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  paddingTop: theme.spacing(5),
  textAlign: 'center',
  width: '100%',
  zIndex: 2,
}));

export { MobileColMenu, MobileContainerMenu, NavigationButton };
